import close_icon from '../images/icon-close-2.svg'
import {useDispatch, useSelector} from "react-redux";
import {
    calc_empty_error,
    checkbox_field_change,
    closeTicket,
    showRequestPopup,
    text_field_change
} from "../redux/actions";
import React from "react";
import {DepartureDate} from "./fields/DepartureDate";
import {CargoName} from "./fields/CargoName";
import {RequestPopup} from "./RequestPopup";
import {SuccessRequest} from "./SuccessRequest";

export const PopupMobile = () => {
    const dispatch = useDispatch()
    const cargoName = useSelector(state => state.app.fields.cargoName.value)
    const avia = useSelector(state => state.app.avia)
    const commision = useSelector(state => state.app.commision)
    const departure_zone = useSelector(state => state.app.departure_zone)
    const destination_zone = useSelector(state => state.app.destination_zone)
    const popup = useSelector(state => state.app.popup)
    const popupChange = useSelector(state => state.app.popupChange)
    const export_price = useSelector(state => state.app.export_price)
    const import_price = useSelector(state => state.app.import_price)
    const advancedOptions = useSelector(state => state.app.advancedOptions)
    const advancedOptionsChange = useSelector(state => state.app.advancedOptionsChange)
    const strahProc = useSelector(state => state.app.strahProc)
    const totalVolume = parseFloat(useSelector(state => state.app.totalVolume))
    const totalWeight = useSelector(state => state.app.totalWeight)
    const cargoType = useSelector(state => state.app.fields.cargoType.value)
    const is_auto1 = useSelector(state => state.app.is_auto1)
    const is_auto2 = useSelector(state => state.app.is_auto2)
    const sale_procent = useSelector(state => state.app.sale_procent)
    const tamog_out = (departure_zone === "RU" && destination_zone === "RU") ? false : true;
    let totalPaidWeight = useSelector(state => state.app.totalPaidWeight)
    let paid_weight = popup.paid_weight;
    let places = popup.places;
    let summ = popup.summ;
    let air_waybill = 0;
    let car_tarif = 0;
    let tarif = summ;
    let summ2 = 0;


    summ += advancedOptions.export ? export_price : 0;
    summ += advancedOptions.import ? import_price : 0;
    summ += advancedOptions.strah ? Math.ceil(parseFloat(advancedOptions.strahValue) * parseFloat(strahProc)) : 0;
    summ += advancedOptions.terminalStart && popup.departure_terminal ? popup.departure_terminal : 0;
    summ += advancedOptions.terminalFinish && popup.arrival_terminal ? popup.arrival_terminal : 0;
    summ += advancedOptions.razmStart ? popup.departure_commission : 0;
    summ += advancedOptions.razmFinish ? popup.destination_commission : 0;

    air_waybill += popup.air_waybill ? popup.air_waybill : 0;
    air_waybill += popup.air_waybill_t ? popup.air_waybill_t : 0;
    air_waybill += popup.air_waybill_l ? popup.air_waybill_l : 0;

    car_tarif += popup.car_to_aeroport ? popup.car_to_aeroport : 0;
    car_tarif += popup.car_from_aeroport ? popup.car_from_aeroport : 0;

    tarif = tarif - air_waybill - car_tarif;

    summ2 = Math.round(summ * commision);
    tarif += summ2 - summ;
    summ = summ2;

    const summ_kg = Math.round(summ / popup.paid_weight)


    if (popup !== false) {
        return (
            <div className="calc_popup">
                <div className="calc_popup__close_back" onClick={() => dispatch(closeTicket())}/>
                <div className="calc_popup__form">
                    <div className="calc_popup__close" onClick={() => dispatch(closeTicket())}>
                        <img src={close_icon} alt="" title=""/>
                        НАЗАД
                    </div>
                    <div className="calc_popup__info">
                        <ul>
                            <li>
                                <span>Тип груза:</span>
                                <span>{cargoType}</span>
                            </li>
                            <li>
                                <span>Кол-во мест:</span>
                                <span>{places}</span>
                            </li>
                            <li>
                                <span>Вес груза (общий):</span>
                                <span>{totalWeight.toFixed(2)} кг</span>
                            </li>
                            <li>
                                <span>Объем груза (общий):</span>
                                <span>{totalVolume < 1 && totalVolume.toFixed(3)}{totalVolume >= 1 && Math.round(totalVolume)} м3</span>
                            </li>
                            <li>
                                <span>Оплачиваемый вес:</span>
                                <span>{totalPaidWeight.toFixed(2)} кг</span>
                            </li>
                        </ul>
                    </div>
                    <div className="calc_popup__itogo">
                        <div className="calc_popup__itogo_label1">
                            Стоимость доставки
                        </div>
                        <div className="calc_popup__itogo_summ1">
                            {
                                sale_procent > 0 && (<span>
                                            {(summ + Math.floor((summ/100)*sale_procent))} руб.
                                        </span>)
                            } {summ} руб.
                        </div>
                        <div className="calc_popup__itogo_summ2">
                            {
                                sale_procent > 0 && (<span>
                                            {(summ_kg + Math.floor((summ_kg/100)*sale_procent))} руб/кг
                                        </span>)
                            } {summ_kg} руб/кг
                        </div>
                        {
                            sale_procent > 0 && (
                                <div className="calc_popup__itogo_sale_procent">Скидка {sale_procent}%</div>
                            )
                        }
                        <div className="calc_popup__itogo_line"/>
                        <div className="calc_popup__itogo_label2">В стоимость входят:</div>
                        {
                            tarif > 0 && (
                                <div
                                    className="calc_popup__itogo_param">Авиатариф: <strong>{Math.round(tarif)} руб.</strong>
                                </div>
                            )
                        }
                        {
                            air_waybill > 0 && (
                                <div
                                    className="calc_popup__itogo_param">Авианакладная: <strong>{Math.round(air_waybill)} руб.</strong>
                                </div>
                            )
                        }
                        {
                            car_tarif > 0 && (
                                <div
                                    className="calc_popup__itogo_param">Автодоставка: <strong>{Math.round(car_tarif)} руб.</strong>
                                </div>)
                        }

                        {
                            car_tarif <= 0 && (is_auto1 > 0 || is_auto2 > 0) && (
                                <div
                                    className="calc_popup__itogo_param">Автодоставка: <strong>Цену уточняйте у
                                    менеджера</strong>
                                </div>
                            )
                        }
                    </div>
                    <div className="calc_popup__date">
                        <DepartureDate/>
                    </div>
                    <div className="calc_popup__path">
                        {
                            popup.path.length > 0 && popup.path.map((item, index) => {
                                if (item.type === 'car_start') {
                                    return (
                                        <div key={index} className="calc_popup__path_item car_start">
                                            <span>{item.name}</span>
                                            <span>{item.country}</span>
                                        </div>
                                    )
                                }
                                if (item.type === 'car') {
                                    return (
                                        <div key={index} className="calc_popup__path_item car">
                                            <span></span>
                                        </div>
                                    )
                                }
                                if (item.type === 'car_finish') {
                                    return (
                                        <div key={index} className="calc_popup__path_item car_finish">
                                            <span>{item.name}</span>
                                            <span>{item.country}</span>
                                        </div>
                                    )
                                }
                                if (item.type === 'aeroport_start') {
                                    return (
                                        <div key={index} className="calc_popup__path_item aeroport_start">
                                            <span>{item.name}</span>
                                            <span>{item.country}</span>
                                        </div>
                                    )
                                }
                                if (item.type === 'airline') {
                                    const airline = item.airline;
                                    let img = item.img;
                                    avia.map((avia_item) => {
                                        if (airline.toLowerCase() === avia_item.code.toLowerCase()) {

                                            img = avia_item.gray_image
                                        }
                                        return null;
                                    })
                                    return (
                                        <div key={index} className="calc_popup__path_item airline">
                                            <img src={img} alt="" title=""/>
                                        </div>
                                    )
                                }
                                if (item.type === 'aeroport_finish') {
                                    return (
                                        <div key={index} className="calc_popup__path_item aeroport_finish">
                                            <span>{item.name}</span>
                                            <span>{item.country}</span>
                                        </div>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                    <div className="calc_popup__advanced">
                        <div className="calc_popup__advanced_heading">Дополнительные услуги:</div>
                        {
                            tamog_out && (
                                <div className="calc_popup__advanced_item">
                                    <label className="calc-checkbox">
                                        <input type="checkbox" name="adv_export"
                                               value={advancedOptions.export}
                                               defaultChecked={advancedOptions.export}
                                               onChange={() => dispatch(checkbox_field_change('adv_export', advancedOptions.export))}
                                        />
                                        <span>Экспортное таможенное оформление <strong>+{export_price} руб.</strong> (до 3 кодов ТНВЭД, далее 1440 руб. за каждый код)</span>
                                    </label>
                                </div>)
                        }
                        {
                            tamog_out && (
                                <div className="calc_popup__advanced_item">
                                    <label className="calc-checkbox">
                                        <input type="checkbox" name="adv_import"
                                               value={advancedOptions.import}
                                               defaultChecked={advancedOptions.import}
                                               onChange={() => dispatch(checkbox_field_change('adv_import', advancedOptions.import))}
                                        />
                                        <span>Импортное таможенное оформление <strong>+{import_price} руб.</strong> (до 3 кодов ТНВЭД, далее 1440 руб. за каждый код)</span>
                                    </label>
                                </div>)
                        }

                        <div className="calc_popup__advanced_item">

                            <label className="calc-checkbox">
                                <input type="checkbox" name="adv_strah"
                                       value={advancedOptions.strah}
                                       defaultChecked={advancedOptions.strah}
                                       onChange={() => dispatch(checkbox_field_change('adv_strah', advancedOptions.strah))}
                                />
                                <span>Страхование груза +{(strahProc * 100)}% от стоимости груза</span>
                            </label>
                            {
                                advancedOptions.strah === true && (
                                    <React.Fragment>
                                        <input type="number" id="adv_strah_value" className="text-input"
                                               name="adv_strah_value" placeholder="Введите стоимость груза"
                                               min="0"
                                               value={advancedOptions.strahValue.toString()}
                                               onChange={(e) => dispatch(text_field_change('adv_strah_value', parseInt(e.target.value)))}
                                        />
                                        <strong>{Math.ceil(parseFloat(advancedOptions.strahValue) * parseFloat(strahProc))} руб.</strong>
                                    </React.Fragment>
                                )
                            }

                        </div>

                        <div className="calc_popup__advanced_item">
                            <label className="calc-checkbox">
                                <input type="checkbox" name="adv_terminal_start"
                                       value={advancedOptions.terminalStart}
                                       defaultChecked={advancedOptions.terminalStart}
                                       onChange={() => dispatch(checkbox_field_change('adv_terminal_start', advancedOptions.terminalStart))}
                                />
                                {
                                    popup.departure_terminal >= 0 && (
                                        <span>Терминальная обработка вылета <strong>+{popup.departure_terminal ? popup.departure_terminal : '0'} руб.</strong></span>
                                    )
                                }
                                {
                                    popup.departure_terminal === undefined && (
                                        <span>Терминальная обработка вылета <strong>Цену уточняйте у менеджера</strong></span>
                                    )
                                }
                            </label>
                        </div>

                        {
                            parseInt(popup.arrival_terminal) >= 0 && (
                                <div className="calc_popup__advanced_item">
                                    <label className="calc-checkbox">
                                        <input type="checkbox" name="adv_terminal_finish"
                                               value={advancedOptions.terminalFinish}
                                               defaultChecked={advancedOptions.terminalFinish}
                                               onChange={() => dispatch(checkbox_field_change('adv_terminal_finish', advancedOptions.terminalFinish))}
                                        />
                                        <span>Терминальная обработка прилета <strong>+{popup.arrival_terminal} руб.</strong></span>
                                    </label>
                                </div>
                            )
                        }


                        <div className="calc_popup__advanced_item">
                            <label className="calc-checkbox">
                                <input type="checkbox" name="adv_razm_start"
                                       value={advancedOptions.razmStart}
                                       defaultChecked={advancedOptions.razmStart}
                                       onChange={() => dispatch(checkbox_field_change('adv_razm_start', advancedOptions.razmStart))}
                                />
                                <span>Размещение в аэропорту вылета  <strong>+{popup.departure_commission} руб.</strong></span>
                            </label>
                        </div>
                        {
                            !tamog_out && (
                                <div className="calc_popup__advanced_item">
                                    <label className="calc-checkbox">
                                        <input type="checkbox" name="adv_razm_finish"
                                               value={advancedOptions.razmFinish}
                                               defaultChecked={advancedOptions.razmFinish}
                                               onChange={() => dispatch(checkbox_field_change('adv_razm_finish', advancedOptions.razmFinish))}
                                        />
                                        <span>Получение в аэропорту прилета  <strong>+{popup.destination_commission} руб.</strong></span>
                                    </label>
                                </div>
                            )
                        }

                        <div className="calc_popup__advanced_item">
                            <label className="calc-checkbox">
                                <input type="checkbox" name="adv_adress_start"
                                       value={advancedOptions.adressStart}
                                       defaultChecked={advancedOptions.adressStart}
                                       onChange={() => dispatch(checkbox_field_change('adv_adress_start', advancedOptions.adressStart))}
                                />
                                <span>Забрать груз от адреса отправителя</span>
                            </label>
                            {
                                advancedOptions.adressStart && (
                                    <textarea type="text" id="adv_adress_start_value" className="text-area"
                                              name="adv_adress_start_value"
                                              placeholder="Введите адрес отправителя"
                                              value={advancedOptions.adressStartValue}
                                              onChange={(e) => dispatch(text_field_change('adv_adress_start_value', e.target.value))}
                                    />
                                )
                            }
                        </div>

                        <div className="calc_popup__advanced_item">
                            <label className="calc-checkbox">
                                <input type="checkbox" name="adv_adress_finish"
                                       value={advancedOptions.adressFinish}
                                       defaultChecked={advancedOptions.adressFinish}
                                       onChange={() => dispatch(checkbox_field_change('adv_adress_finish', advancedOptions.adressFinish))}
                                />
                                <span>Доставить груз до адреса получателя</span>
                            </label>
                            {
                                advancedOptions.adressFinish && (
                                    <textarea type="text" id="adv_adress_finish_value" className="text-area"
                                              name="adv_adress_finish_value"
                                              placeholder="Введите адрес получателя"
                                              value={advancedOptions.adressFinishValue}
                                              onChange={(e) => dispatch(text_field_change('adv_adress_finish_value', e.target.value))}
                                    />
                                )
                            }
                        </div>
                    </div>
                    <div className="calc_popup__adress">
                        <CargoName/>
                    </div>
                    <div className="calc_popup__itogo2">
                        <div className="calc_popup__itogo_label1">
                            Стоимость доставки
                        </div>
                        <div className="calc_popup__itogo_summ1">
                            {
                                sale_procent > 0 && (<span>
                                            {(summ + Math.floor((summ/100)*sale_procent))} руб.
                                        </span>)
                            } {summ} руб.
                        </div>
                        <div className="calc_popup__itogo_summ2">
                            {
                                sale_procent > 0 && (<span>
                                            {(summ_kg + Math.floor((summ_kg/100)*sale_procent))} руб/кг
                                        </span>)
                            } {summ_kg} руб/кг
                        </div>
                        {
                            sale_procent > 0 && (
                                <div className="calc_popup__itogo_sale_procent">Скидка {sale_procent}%</div>
                            )
                        }
                    </div>
                    <div className="calc_popup__submit btn btn__size_2 btn__orange"
                         onClick={() => {
                             if (cargoName === '') {
                                 return dispatch(calc_empty_error(['cargoName']))
                             }
                             return dispatch(showRequestPopup())
                         }}>
                        Получить точный расчет
                    </div>
                    <RequestPopup/>
                    <SuccessRequest/>
                </div>
            </div>
        )
    }
    return popupChange && advancedOptionsChange;
}